import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPC_CHANNEL, STANDALONE } from '../../_offline/electron.constants';
import { InspectionQueryOpt, InspectionSchema, InspectionSchemaLocationUpdate, InspectionSchemaStatusUpdate, InspectionSchemaUpdate } from '../../_offline/models/inspection.schema';
import { DatabaseBaseService } from '../base/database-base.service';
import { LoginUserOfflineService } from '../offline/login-user-offline.service';
import { SubjectFilter } from '../storage.service';
import { map } from 'rxjs/operators';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class InspectionDbService extends DatabaseBaseService {

  get userId() {
    return this.loginUserService.loginUser?.id;
  }

  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  getListAll(statusCode?: string, subjectFilter?: SubjectFilter, isOwn?: boolean,
    sort?: { active: string; direction: string; }): Observable<InspectionSchema[]> {

    const inspOpt = new InspectionQueryOpt(this.tenantId, this.userId, statusCode, subjectFilter, isOwn, sort);
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION.GET_LIST_ALL, inspOpt);
  }

  getAllOnPremise(): Observable<InspectionSchema[]> {
    const inspOpt = new InspectionQueryOpt(STANDALONE.TENANT_ID, STANDALONE.USER_ID);
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION.GET_LIST_ALL, inspOpt);
  }

  getListById(inspectionId: string[], isAliveOnly = false): Observable<InspectionSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION.GET_LIST_BY_ID, this.tenantId, this.userId, inspectionId, isAliveOnly);
  }

  getInspection(id: string, aliveOnly: boolean, tenantId?: string, isForce = false): Observable<InspectionSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION.GET_ONE, tenantId ?? this.tenantId, this.userId, id, aliveOnly, isForce);
  }

  putListAll(inspectionList: InspectionSchema[]): Observable<InspectionSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION.PUT_LIST_ALL, inspectionList);
  }

  addInspection(inspection: InspectionSchema): Observable<InspectionSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION.PUT_ONE, inspection);
  }

  updateInspection(inspection: InspectionSchemaUpdate): Observable<InspectionSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION.PUT_ONE, inspection);
  }

  updateInspectionLocations(inspection: InspectionSchemaLocationUpdate): Observable<InspectionSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION.PUT_ONE, inspection);
  }

  updateInspectionStatus(inspection: InspectionSchemaStatusUpdate): Observable<InspectionSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION.PUT_ONE, inspection);
  }

  deleteInspection(inspectionId: string, isLogicalDelete = true): Observable<InspectionSchema> {
    return this.ipcSendSync(IPC_CHANNEL.INSPECTION.DELETE_ONE, inspectionId, isLogicalDelete);
  }

  hasInspections(subjectId: string): Observable<boolean> {
    return this.ipcSendSync(
      IPC_CHANNEL.INSPECTION.IS_INSPECTION_USING_SUBJECTID_EXISTS,
      subjectId,
      this.tenantId
    ).pipe(map((x) => x as boolean));
  }
}
